import React from 'react';
import 'twin.macro';
import { useLocation, useOutletContext } from 'react-router-dom';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import useUpdateUser from '@teetsh/app/src/queries/user/useUpdateUser';
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from '@teetsh/app/src/components/Resizable';
import { Sidebar } from './Sidebar';
import { Body } from './Body';
import { Form } from 'react-final-form';
import AutoSubmitForm from '@teetsh/app/src/components/AutoSave';
import { useUserAccount } from '@teetsh/app/src/queries/user/account/useUserAccount';
import { useDownloadCarnet } from 'containers/CarnetsDeNotes/queries/useDownloadCarnet';
import {
  CarnetDeNotes,
  CarnetDeNotesPdfSettings,
} from 'containers/CarnetsDeNotes/types/carnetsDeNotes';
import { GroupBy } from 'containers/CarnetsDeNotes/CarnetDetails/types';

export function CarnetsDeNotesPreview() {
  const user = useUser();
  const updateUser = useUpdateUser();
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const groupBy = (urlSearchParams.get('groupby') || 'evaluation') as GroupBy;

  const { data: userAccount } = useUserAccount();
  const context = useOutletContext<{
    carnetDeNotes: CarnetDeNotes;
  }>();
  const { carnetDeNotes } = context;

  const { download: downloadCarnet, isDownloading } = useDownloadCarnet();

  return (
    <Form<CarnetDeNotesPdfSettings>
      initialValues={user.fonts.carnet}
      onSubmit={async values => {
        await updateUser({
          ...user,
          fonts: {
            ...user.fonts,
            carnet: values,
          },
        });
        return {};
      }}
    >
      {({ handleSubmit }) => (
        <form tw="min-h-0 h-full" onSubmit={handleSubmit}>
          <AutoSubmitForm />
          <div tw="w-full h-full flex flex-col overflow-hidden">
            <ResizablePanelGroup
              direction="horizontal"
              autoSaveId="carnet-de-notes-preview-sidebar"
            >
              <Sidebar
                isDownloading={isDownloading}
                onDownload={() =>
                  downloadCarnet({
                    lng: user.locale,
                    carnetDeNotes,
                    settings: user.fonts.carnet,
                    groupBy,
                  })
                }
                limitedBgSet={userAccount?.isOnOldPricing || false}
              />
              <ResizableHandle />
              <ResizablePanel order={1}>
                <div tw="h-full overflow-auto">
                  <Body
                    groupBy={groupBy}
                    cdnId={carnetDeNotes.id}
                    userId={user.id}
                    lng={user.locale}
                  />
                </div>
              </ResizablePanel>
            </ResizablePanelGroup>
          </div>
        </form>
      )}
    </Form>
  );
}
